"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames4 = _interopRequireDefault(require("classnames"));

var _Input = _interopRequireDefault(require("../Input"));

var _events = _interopRequireDefault(require("../../utils/events"));

var _InputContainer = _interopRequireDefault(require("../Input/InputContainer"));

var _Menu = require("../Menu");

var _ThemeProvider = require("../../ThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Dropdown =
/*#__PURE__*/
function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Dropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false,
      up: false
    });

    _defineProperty(_assertThisInitialized(_this), "getDocumentEvents", function () {
      return {
        click: _this.handleDocumentClick,
        touchend: _this.handleDocumentClick
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectedItem", function () {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _this.props.source[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          if (item[_this.props.valueKey] === _this.props.value) return item;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return !_this.props.allowBlank ? _this.props.source[0] : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (item, event) {
      if (_this.props.onBlur) _this.props.onBlur(event);

      if (!_this.props.disabled && _this.props.onChange) {
        if (_this.props.name) event.target.name = _this.props.name;

        _this.props.onChange(item, event);

        _this.close();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      _this.open(event);

      _events["default"].pauseEvent(event);

      if (_this.props.onClick) _this.props.onClick(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDocumentClick", function (event) {
      if (_this.state.active && !_events["default"].targetIsDescendant(event, _reactDom["default"].findDOMNode(_assertThisInitialized(_this)))) {
        _this.setState({
          active: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      if (_this.state.active) {
        _this.setState({
          active: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "open", function (event) {
      if (_this.state.active) return;
      var client = event.target.getBoundingClientRect();
      var screenHeight = window.innerHeight || document.documentElement.offsetHeight;
      var up = _this.props.auto ? client.top > screenHeight / 2 + client.height : false;

      _this.setState({
        active: true,
        up: up
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      event.stopPropagation();

      _this.dropdown.focus();

      if (!_this.props.disabled) _this.open(event);
      if (_this.props.onFocus) _this.props.onFocus(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      event.stopPropagation();
      if (_this.state.active) _this.close();
      if (_this.props.onBlur) _this.props.onBlur(event);
    });

    _defineProperty(_assertThisInitialized(_this), "renderValue", function (item, idx) {
      var _classnames;

      var _this$props = _this.props,
          labelKey = _this$props.labelKey,
          theme = _this$props.theme,
          valueKey = _this$props.valueKey;
      var className = (0, _classnames4["default"])((_classnames = {}, _defineProperty(_classnames, theme.selected, item[valueKey] === _this.props.value), _defineProperty(_classnames, theme.disabled, item.disabled), _classnames));
      return _react["default"].createElement("li", {
        key: idx,
        className: className,
        onMouseDown: !item.disabled && _this.handleSelect.bind(_assertThisInitialized(_this), item[valueKey])
      }, _this.props.template ? _this.props.template(item) : item[labelKey]);
    });

    return _this;
  }

  _createClass(Dropdown, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (!this.state.active && nextState.active) {
        _events["default"].addEventsToDocument(this.getDocumentEvents());
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.active && !this.state.active) {
        _events["default"].removeEventsFromDocument(this.getDocumentEvents());
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.active) {
        _events["default"].removeEventsFromDocument(this.getDocumentEvents());
      }
    }
  }, {
    key: "renderTemplateValue",
    value: function renderTemplateValue(selected) {
      var _classnames2;

      var theme = this.props.theme;
      var className = (0, _classnames4["default"])(theme.field, (_classnames2 = {}, _defineProperty(_classnames2, theme.errored, this.props.error), _defineProperty(_classnames2, theme.disabled, this.props.disabled), _defineProperty(_classnames2, theme.required, this.props.required), _classnames2));
      return _react["default"].createElement("div", {
        className: className,
        onClick: this.handleClick
      }, _react["default"].createElement("div", {
        className: "".concat(theme.templateValue, " ").concat(theme.value)
      }, this.props.template(selected)), this.props.label ? _react["default"].createElement("label", {
        className: theme.label
      }, this.props.label, this.props.required ? _react["default"].createElement("span", {
        className: theme.required
      }, " * ") : null) : null, this.props.error ? _react["default"].createElement("span", {
        className: theme.error
      }, this.props.error) : null);
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames3,
          _this2 = this;

      var _this$props2 = this.props,
          labelKey = _this$props2.labelKey,
          required = _this$props2.required,
          source = _this$props2.source,
          template = _this$props2.template,
          theme = _this$props2.theme,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          label = _this$props2.label,
          allowBlank = _this$props2.allowBlank,
          auto = _this$props2.auto,
          onChange = _this$props2.onChange,
          onFocus = _this$props2.onFocus,
          onBlur = _this$props2.onBlur,
          valueKey = _this$props2.valueKey,
          others = _objectWithoutProperties(_this$props2, ["labelKey", "required", "source", "template", "theme", "className", "disabled", "label", "allowBlank", "auto", "onChange", "onFocus", "onBlur", "valueKey"]);

      var _this$state = this.state,
          active = _this$state.active,
          up = _this$state.up;
      var selected = this.getSelectedItem();
      var classNames = (0, _classnames4["default"])(theme.dropdown, (_classnames3 = {}, _defineProperty(_classnames3, theme.up, up), _defineProperty(_classnames3, theme.active, active), _defineProperty(_classnames3, theme.disabled, disabled), _defineProperty(_classnames3, theme.required, required), _classnames3), className);
      return _react["default"].createElement(_InputContainer["default"], null, _react["default"].createElement("div", {
        ref: function ref(dropdown) {
          _this2.dropdown = dropdown;
        },
        className: classNames,
        "data-react-toolbox": "dropdown",
        tabIndex: "-1",
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      }, _react["default"].createElement(_Input["default"], _extends({}, others, {
        onClick: this.handleClick,
        tabIndex: "0",
        className: theme.value,
        required: required,
        readOnly: true,
        type: template && selected ? 'hidden' : null,
        theme: {
          inputElementWrap: theme.inputElementWrap
        },
        value: selected && selected[labelKey] ? selected[labelKey] : '',
        label: label,
        icon: active ? 'keyboard_arrow_up' : 'keyboard_arrow_down',
        iconPos: "right"
      })), template && selected ? this.renderTemplateValue(selected) : null, _react["default"].createElement("ul", {
        className: theme.values
      }, source.map(this.renderValue))));
    }
  }]);

  return Dropdown;
}(_react.Component);

_defineProperty(Dropdown, "propTypes", {
  allowBlank: _propTypes["default"].bool,
  auto: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  error: _propTypes["default"].string,
  label: _propTypes["default"].string,
  labelKey: _propTypes["default"].string,
  name: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  required: _propTypes["default"].bool,
  source: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])).isRequired,
  template: _propTypes["default"].func,
  theme: _propTypes["default"].shape({
    active: _propTypes["default"].string,
    disabled: _propTypes["default"].string,
    dropdown: _propTypes["default"].string,
    error: _propTypes["default"].string,
    errored: _propTypes["default"].string,
    field: _propTypes["default"].string,
    label: _propTypes["default"].string,
    required: _propTypes["default"].string,
    selected: _propTypes["default"].string,
    templateValue: _propTypes["default"].string,
    up: _propTypes["default"].string,
    value: _propTypes["default"].string,
    values: _propTypes["default"].string
  }),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  valueKey: _propTypes["default"].string
});

_defineProperty(Dropdown, "defaultProps", {
  auto: true,
  className: '',
  allowBlank: true,
  disabled: false,
  labelKey: 'label',
  required: false,
  valueKey: 'value'
});

var _default = (0, _ThemeProvider.applyTheme)('Dropdown', Dropdown);

exports["default"] = _default;